import React from 'react';
import { Field } from 'redux-form';
import { Button, Col, Row, Spin, Select } from 'antd';
import { SelectField } from '../../../services/ant-redux';

const StateTab = ({
  fetchState,
  data,
  handleChange,
  fetching,
  value,
  handleSubmit,
  submitting,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field
        mode="multiple"
        showSearch
        value={value}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        onSearch={fetchState}
        onChange={handleChange}
        name="states"
        component={SelectField}
        placeholder="Search States"
      >
        {data.map(d => (
          <Select.Option key={d.value}>{d.text}</Select.Option>
        ))}
      </Field>

      <Row type="flex" align="top" justify="space-between">
        <Col>
          <Button onClick={handleSubmit} loading={submitting}>
            Include
          </Button>
        </Col>
      </Row>
    </form>
  </div>
);

export default StateTab;
